import TableLoader from "../../../../general/table/tableLoader";
import EmptyRow from "../../../../general/table/emptyRow";
import React from "react";
import PatientBiometricTableRowItem from "./patientBiometricTable_rowItem";

type PatientBiometricsTableProps = {
  dataList?: any;
  dataListTitles: string[];
  isRequesting: boolean;
  readonly?: boolean;
}

const PatientBiometricsTable = ({
  dataList,
  dataListTitles,
  isRequesting,
  readonly = false
}: PatientBiometricsTableProps) => {
  const _dataListTitles = dataListTitles.map((item, i) => <td key={i}>{item}</td>),
    _dataList = dataList?.data && dataList?.data.length > 0 && dataList?.data.map((item: any, i: number) => {
      return <PatientBiometricTableRowItem item={item} key={i} readonly={readonly}/>
    });

  return (
    <table>
      <thead>
      <tr className={`${readonly && 'text-black fw-semibold'}`}>
        {_dataListTitles}
      </tr>
      </thead>
      <tbody>
      {isRequesting ?
        <TableLoader colSpan={dataListTitles.length}/> :
        _dataList ? _dataList : <EmptyRow colSpan={dataListTitles.length} content={''}/>
      }
      </tbody>
    </table>
  )
}

export default PatientBiometricsTable;
